SetDesign(function($, _, window, document) {
    var selector = "[data-lazy-bg]";
    var checkBackgrounds = function() {
        var $this = $(this);
        SetDesign.addImageToLoadQueue($this.data("lazyBg"), function(img) {
            $this.css("background-image", 'url("' + img.src + '")').removeAttr("data-lazy-bg")
        })
    };
    SetDesign.scrollWatch($(selector), checkBackgrounds);
    SetDesign.addAction("refreshLazyLoad", function($container) {
        $container.find(selector).each(checkBackgrounds)
    })
});
SetDesign(function($, _, window, document) {
    var addAction = SetDesign.addAction;
    var doAction = SetDesign.doAction;
    var selector = ".lazy-image";
    var ImageLoadTask = function($image) {
        this.$image = $($image);
        this.$parent = this.$image.parent();
        this.attributes = this.$image.data("lazy-image");
        this.cssClass = this.$image.attr("class").replace("lazy-image", "lazy-image-loaded")
    };
    ImageLoadTask.prototype.onLoad = function(image) {
        image.className = this.cssClass;
        for (var key in this.attributes) {
            if (this.attributes.hasOwnProperty(key) && key !== "src") {
                image.setAttribute(key, this.attributes[key])
            }
        }
        this.$image.replaceWith(image);
        setTimeout(function() {
            this.$parent.removeClass("image-loading");
            this.$parent.addClass("image-loaded")
        }.bind(this), 10)
    };
    ImageLoadTask.prototype.run = function() {
        if (!this.attributes.src) {
            return false
        }
        this.$parent.addClass("image-loading");
        SetDesign.addImageToLoadQueue(this.attributes.src, this.onLoad.bind(this))
    };
    var checkImages = function() {
        var $image = $(this);
        if (!$image.hasClass("in-view")) {
            $image.addClass("in-view");
            var loader = new ImageLoadTask($image);
            loader.run()
        }
    };
    SetDesign.scrollWatch($(selector), checkImages);
    addAction("refreshLazyLoad", function($container) {
        $container.find(selector).each(checkImages)
    });
    addAction("showModal", function($modal) {
        doAction("refreshLazyLoad", $modal)
    }, 20)
});
(function(SetDesign) {
    var queueItems = [];
    var currentlyLoading = 0;
    var loadingMax = 3;

    function onImageLoad(img, task) {
        task.callback(img);
        currentlyLoading--;
        executeQueue()
    }

    function executeTask(task) {
        var img = new Image;
        img.addEventListener("load", onImageLoad.bind(this, img, task), {
            once: true
        });
        img.src = task.src
    }

    function executeQueue() {
        if (!queueItems.length || currentlyLoading > loadingMax) {
            return false
        }
        currentlyLoading++;
        executeTask(queueItems.shift())
    }
    SetDesign.addImageToLoadQueue = function(imgSrc, callback) {
        queueItems.push({
            src: imgSrc,
            callback: callback
        });
        executeQueue()
    }
})(SetDesign);